import { axiosV0 } from 'api/api';
import { DataStore } from 'mobx/dataStore';

export const dataApi = {
  getData: async () => {
    const res = await axiosV0.get<DataStore.Data>('/get_data');

    return res.data;
  },
};
